export default __webpack_public_path__ + "static/media/jaid.6187100d.png";